import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import { currentHealthboardOptionsActions } from '../../redux/profiles/patientHealthboard/currentHealthboardOptions';
import * as historicData from '../../redux/profiles/patientHealthboard/historic-measurements-req';
import { actions as uiDrawerActions } from '../../redux/ui/drawer';
import { actions as contextActions } from '../../redux/context';
import { uiDrawerSelector } from '../../redux/ui/selectors';
import {
  selectCurrentHealthboardOptionsChartPeriod,
  selectCurrentHealthboardOptionsDataType,
  selectVitalsActivityEntity,
} from '../../redux/profiles/patientHealthboard/selectors';
import {
  selectAvailableCategoriesPending,
  selectDeepLinkDependentId,
  selectDeepLinkTab,
  selectMedicationsRefillsHistoryList,
} from '../../redux/healthboard/patientPortal/selectors';
import {
  hasProviderProfileSelector,
  loggedUserSelector,
  targetUserSelector,
} from '../../redux/context/selectors';
import styles from './index.styl';

const mapStateToProps = state => ({
  profile: loggedUserSelector(state),
  profileTargetUser: targetUserSelector(state),
  isProvider: hasProviderProfileSelector(state),
  vitalsActivityData: selectVitalsActivityEntity(state),
  activeCardType: selectCurrentHealthboardOptionsDataType(state),
  activeFilter: selectCurrentHealthboardOptionsChartPeriod(state),
  deepLinkTab: selectDeepLinkTab(state),
  deepLinkDependentId: selectDeepLinkDependentId(state),
  drawerVisibility: uiDrawerSelector(state),
  availableCategoriesPending: selectAvailableCategoriesPending(state),
  refillsHistory: selectMedicationsRefillsHistoryList(state),
});

const mapDispatchToProps = {
  setActiveCardType: currentHealthboardOptionsActions.setDataType,
  setActiveFilter: currentHealthboardOptionsActions.setChartPeriod,
  toggleDrawer: uiDrawerActions.toggleVisibility,
  setTargetUserId: contextActions.setTargetUserId,
  clearHistoricData: historicData.actions.clear,
};
export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/enhance.js